import React, { useEffect, useState } from 'react';
import { CreditCard, Smartphone, ArrowLeft, Check, Plus, Trash2 } from 'lucide-react';

const PaymentMethodsModal = ({ isOpen, onClose, paymentMethods, setPaymentMethods, showToast, upiQrCode = '/static/upi-qr.jpeg', upiId = '' }) => {
  const [showAddForm, setShowAddForm] = useState(false);
  const [newMethod, setNewMethod] = useState({ type: 'UPI', details: '' });

  useEffect(() => {
    if (!isOpen || typeof document === 'undefined') {
      return undefined;
    }

    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = document.documentElement.style.overflow;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
    };
  }, [isOpen]);

  if (!isOpen) return null;

 
  const handleSetDefault = (id) => {
    setPaymentMethods(
      paymentMethods.map(method => ({
        ...method,
        default: method.id === id
      }))
    );
  };

  const handleDeleteMethod = (id) => {
    if (window.confirm('Are you sure you want to remove this payment method?')) {
      setPaymentMethods(paymentMethods.filter(method => method.id !== id));
    }
  };

  const handleAddMethod = () => {
    if (!newMethod.details.trim()) {
      showToast('Please enter payment details', 'warning');
      return;
    }

    const newId = Math.max(...paymentMethods.map(m => m.id), 0) + 1;
    setPaymentMethods([
      ...paymentMethods,
      {
        id: newId,
        type: newMethod.type,
        details: newMethod.details,
        default: paymentMethods.length === 0
      }
    ]);

    setNewMethod({ type: 'UPI', details: '' });
    setShowAddForm(false);
    showToast('Payment method added successfully!', 'success');
  };

  const getMethodIcon = (type) => {
    switch (type) {
      case 'UPI':
        return <Smartphone size={24} className="text-[#ff3f6c]" />;
      case 'Card':
        return <CreditCard size={24} className="text-[#ff3f6c]" />;
      default:
        return <CreditCard size={24} className="text-[#535766]" />;
    }
  };

  return (
    <div className="fixed inset-0 z-[200] bg-slate-50 page-overlay-scroll">
      <div className="w-full max-w-md mx-auto min-h-full pb-20 bg-gray-50">
        <div className="bg-[#ff3f6c] text-white p-6 rounded-none">
          <div className="flex items-center justify-between mb-2">
            <button
              onClick={onClose}
              className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-all"
              title="Go back"
              style={{ color: 'var(--text-light)' }}
            >
              <ArrowLeft size={22} />
            </button>
          </div>
          <h1 className="text-2xl font-bold">Payment Methods</h1>
          <p className="text-[#94969f]">Manage saved payment options securely</p>
        </div>
          {/* Merchant UPI Section */}
          <div className="mt-6 bg-[#fff8fa] border border-[#eaeaec] rounded p-4">
            <div className="flex items-center gap-2 mb-3">
              <Smartphone size={18} className="text-[#ff3f6c]" />
              <h4 className="font-semibold text-[#282c3f] text-sm">Pay via UPI at Delivery</h4>
            </div>
            <div className="flex flex-col items-center">
              <img
                src={upiQrCode}
                alt="Merchant UPI QR Code"
                style={{ width: 160, height: 160, borderRadius: 10, display: 'block' }}
              />
              {upiId && (
                <p className="text-sm font-semibold text-[#ff3f6c] mt-2 text-center">{upiId}</p>
              )}
              <p className="text-xs text-[#ff3f6c] mt-1 text-center">Scan this QR code to pay via UPI at delivery</p>
            </div>
          </div>
         
        <div className="p-4">
           {/* Payment Methods List & Add Form 
          {paymentMethods.length === 0 ? (
            <div className="bg-white rounded shadow-sm text-center py-12 px-4">
              <CreditCard size={64} className="text-gray-300 mx-auto mb-4" />
              <p className="text-[#94969f] mb-6">No payment methods added yet</p>
              <button
                onClick={() => setShowAddForm(true)}
                className="bg-[#ff3f6c] text-white px-6 py-3 rounded font-medium hover:shadow-lg transition-all"
              >
                Add Payment Method
              </button>
            </div>
          ) : (
            <>
              <div className="space-y-3 mb-6">
                {paymentMethods.map((method) => (
                  <div
                    key={method.id}
                    className={`bg-gradient-to-br ${
                      method.type === 'UPI'
                        ? ' border-[#eaeaec]'
                        : ' border-[#eaeaec]'
                    } border rounded p-4 ${
                      method.default ? 'ring-2 ring-green-500' : ''
                    }`}
                  >
                    <div className="flex items-start justify-between">
                      <div className="flex items-start gap-3">
                        {getMethodIcon(method.type)}
                        <div>
                          <div className="flex items-center gap-2">
                            <p className="font-semibold text-[#282c3f]">
                              {method.type}
                            </p>
                            {method.default && (
                              <span className="bg-[#03a685] text-white text-xs px-2 py-0.5 rounded-full flex items-center gap-1">
                                <Check size={12} />
                                Default
                              </span>
                            )}
                          </div>
                          <p className="text-sm text-[#535766] mt-1">
                            {method.details}
                          </p>
                          {!method.default && (
                            <button
                              onClick={() => handleSetDefault(method.id)}
                              className="text-xs text-[#ff3f6c] hover:underline mt-2"
                            >
                              Set as default
                            </button>
                          )}
                        </div>
                      </div>
                      <button
                        onClick={() => handleDeleteMethod(method.id)}
                        className="text-red-500 hover:bg-red-50 rounded-full p-2 transition-all"
                      >
                        <Trash2 size={18} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              {!showAddForm && (
                <button
                  onClick={() => setShowAddForm(true)}
                  className="w-full border border-dashed border-[#eaeaec] rounded py-4 text-[#535766] hover:border-[#ff3f6c] hover:text-[#ff3f6c] transition-all flex items-center justify-center gap-2 bg-white"
                >
                  <Plus size={20} />
                  Add New Payment Method
                </button>
              )}
            </>
          )}

          
          {showAddForm && (
            <div className="bg-[#fafafa] rounded p-4 border border-[#eaeaec] mt-4">
              <h3 className="font-semibold text-[#282c3f] mb-4">
                Add Payment Method
              </h3>

              <div className="space-y-4">
               
                <div>
                  <label className="block text-sm font-medium text-[#535766] mb-2">
                    Payment Type
                  </label>
                  <div className="flex gap-2">
                    <button
                      onClick={() => setNewMethod({ ...newMethod, type: 'UPI' })}
                      className={`flex-1 py-3 rounded border transition-all flex items-center justify-center gap-2 ${
                        newMethod.type === 'UPI'
                          ? 'border-[#ff3f6c] bg-[#fff8fa] text-[#ff3f6c]'
                          : 'border-[#eaeaec] text-[#535766] hover:border-[#ff3f6c]'
                      }`}
                    >
                      <Smartphone size={20} />
                      UPI
                    </button>
                    <button
                      onClick={() => setNewMethod({ ...newMethod, type: 'Card' })}
                      className={`flex-1 py-3 rounded border transition-all flex items-center justify-center gap-2 ${
                        newMethod.type === 'Card'
                          ? 'border-[#ff3f6c] bg-[#fff8fa] text-[#ff3f6c]'
                          : 'border-[#eaeaec] text-[#535766] hover:border-[#ff3f6c]'
                      }`}
                    >
                      <CreditCard size={20} />
                      Card
                    </button>
                  </div>
                </div>

               
                <div>
                  <label className="block text-sm font-medium text-[#535766] mb-2">
                    {newMethod.type === 'UPI' ? 'UPI ID' : 'Card Number'}
                  </label>
                  <input
                    type="text"
                    value={newMethod.details}
                    onChange={(e) =>
                      setNewMethod({ ...newMethod, details: e.target.value })
                    }
                    placeholder={
                      newMethod.type === 'UPI'
                        ? 'yourname@upi'
                        : '**** **** **** 1234'
                    }
                    className="w-full px-4 py-3 border border-[#eaeaec] rounded focus:ring-2 focus:ring-[#ff3f6c] focus:border-[#ff3f6c] outline-none"
                  />
                </div>

              
                <div className="flex gap-2">
                  <button
                    onClick={() => {
                      setShowAddForm(false);
                      setNewMethod({ type: 'UPI', details: '' });
                    }}
                    className="flex-1 py-3 bg-gray-200 text-[#535766] rounded font-medium hover:bg-gray-300 transition-all"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleAddMethod}
                    className="flex-1 py-3 bg-[#ff3f6c] text-white rounded font-medium hover:shadow-lg transition-all"
                  >
                    Add Method
                  </button>
                </div>
              </div>
            </div>
          )}
         */}
        

          {/* Info Section */}
          <div className="mt-4 bg-[#fff8fa] border border-[#eaeaec] rounded p-4">
            <h4 className="font-semibold text-[#282c3f] text-sm mb-2">
              🔒 Secure Payments
            </h4>
            <p className="text-xs text-[#535766]">
              Your payment information is encrypted and stored securely. We never
              share your payment details with third parties.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodsModal;